<template>
  <div @click="close" class="m-4 flex flex-col rounded-lg" :class="bgColor">
    <div class="py-2 px-4" :class="textColor">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Notification",
  data() {
    return {
      textColor: "",
      bgColor: ""
    };
  },
  props: {
    type: {
      type: String,
      default: "success"
    },
    close: Function
  },
  created() {
    switch (this.type) {
      default:
        this.textColor = "text-green-900";
        this.bgColor = "bg-green-200";
        break;
      case "warning":
        this.textColor = "text-yellow-900";
        this.bgColor = "bg-yellow-200";
        break;
      case "danger":
        this.textColor = "text-red-900";
        this.bgColor = "bg-red-200";
        break;
    }
  }
};
</script>